var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fastag"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.67181 18.6287C8.72704 18.6287 8.77181 18.584 8.77181 18.5287V13.5116C8.77181 13.4863 8.78146 13.4618 8.79882 13.4433L10.5044 11.6219C10.5643 11.558 10.519 11.4535 10.4315 11.4535H8.87181C8.81658 11.4535 8.77181 11.4087 8.77181 11.3535V5.03519C8.77181 4.46347 8.30174 4 7.72188 4H3.83714C3.25728 4 2.78721 4.46347 2.78721 5.03519L2.78768 18.5287C2.78768 18.584 2.83245 18.6287 2.88768 18.6287H8.67181ZM4.93954 5.08692C4.35968 5.08692 3.88961 5.55039 3.88961 6.12211V10.2629C3.88961 10.8346 4.35968 11.2981 4.93954 11.2981H6.61942C7.19928 11.2981 7.66935 10.8346 7.66935 10.2629V6.12211C7.66935 5.55039 7.19928 5.08692 6.61942 5.08692H4.93954Z",
    stroke: "#183883",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04993 18.5962C2.47007 18.5962 2 19.0597 2 19.6314V19.8937C2 19.9489 2.04477 19.9937 2.1 19.9937H9.45949C9.51472 19.9937 9.55949 19.9489 9.55949 19.8937V19.6314C9.55949 19.0597 9.08942 18.5962 8.50956 18.5962H3.04993Z",
    stroke: "#183883",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0914 13.359L10.6639 14.2021C10.6472 14.2349 10.6138 14.2558 10.577 14.2574C10.0556 14.2801 9.87332 14.4299 9.87332 14.9725V18.0298C9.87332 18.0851 9.91809 18.1298 9.97332 18.1298H10.5614C10.6166 18.1298 10.6614 18.1746 10.6614 18.2298V19.0619C10.6614 19.5765 11.0845 19.9936 11.6064 19.9936C12.1282 19.9936 12.5513 19.5765 12.5513 19.0619V18.2298C12.5513 18.1746 12.5961 18.1298 12.6513 18.1298H19.223C19.2782 18.1298 19.323 18.1746 19.323 18.2298V19.0619C19.323 19.5765 19.7461 19.9936 20.2679 19.9936C20.7898 19.9936 21.2129 19.5765 21.2129 19.0619V18.2298C21.2129 18.1746 21.2576 18.1298 21.3129 18.1298H21.9C21.9552 18.1298 22 18.0851 22 18.0298V14.9725C22 14.4008 21.5299 13.9373 20.9501 13.9373V13.9373C20.9186 13.9373 20.8902 13.9185 20.8779 13.8896L19.5068 10.6601C19.4911 10.6231 19.4549 10.5991 19.4147 10.5991H12.4573C12.4186 10.5991 12.3834 10.6215 12.3669 10.6565L11.0914 13.359ZM12.9345 11.5308C12.8934 11.5308 12.8565 11.556 12.8415 11.5943L11.9752 13.8008C11.9494 13.8664 11.9978 13.9373 12.0683 13.9373H19.7323C19.8015 13.9373 19.8498 13.8686 19.8264 13.8034L19.0323 11.597C19.018 11.5573 18.9803 11.5308 18.9382 11.5308H12.9345Z",
    stroke: "#183883",
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Union_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1202 2.06659C16.0783 2.02993 16.0146 2.03451 15.9784 2.07677L14.9983 3.22086C14.9427 3.28573 14.9888 3.38592 15.0743 3.38592H17.361C17.4534 3.38592 17.4964 3.27149 17.4269 3.21068L16.1202 2.06659Z",
    stroke: "#183883",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0324 4.44577C14.0029 4.44577 13.9749 4.45881 13.9559 4.48139L13.0952 5.50426C13.0405 5.5693 13.0867 5.66864 13.1717 5.66864H15.6805C15.71 5.66864 15.738 5.6556 15.757 5.63302L16.6177 4.61016C16.6724 4.54511 16.6261 4.44577 16.5411 4.44577H14.0324Z",
    stroke: "#183883",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1141 7.95126C11.0291 7.95126 10.9828 7.85192 11.0376 7.78688L11.8982 6.76401C11.9172 6.74143 11.9452 6.72839 11.9747 6.72839H14.4835C14.5685 6.72839 14.6147 6.82773 14.56 6.89278L13.6994 7.91564C13.6804 7.93823 13.6524 7.95126 13.6228 7.95126H11.1141Z",
    stroke: "#183883",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0755 9.01102C10.0459 9.01102 10.0179 9.02405 9.99894 9.04663L9.13831 10.0695C9.08358 10.1345 9.12982 10.2339 9.21483 10.2339H11.7236C11.7531 10.2339 11.7811 10.2208 11.8001 10.1983L12.6607 9.1754C12.7155 9.11035 12.6692 9.01102 12.5842 9.01102H10.0755Z",
    stroke: "#183883",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1875 16.0217C21.1875 16.562 20.7623 17 20.2377 17C19.7132 17 19.288 16.562 19.288 16.0217C19.288 15.4814 19.7132 15.0434 20.2377 15.0434C20.7623 15.0434 21.1875 15.4814 21.1875 16.0217ZM12.1648 17C12.6893 17 13.1145 16.562 13.1145 16.0217C13.1145 15.4814 12.6893 15.0434 12.1648 15.0434C11.6402 15.0434 11.215 15.4814 11.215 16.0217C11.215 16.562 11.6402 17 12.1648 17Z",
    stroke: "#183883",
    strokeWidth: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastag);
export default __webpack_public_path__ + "static/media/Fastag.66f6f551eb55c2023d02b97b3c5bcc34.svg";
export { ForwardRef as ReactComponent };